import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPedroNarnia = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M9.28541 8.22709L8.65358 8.47651L8.73709 9.15063L10.5637 23.897L10.659 24.6662H11.4341H20.1252H20.9078L20.9965 23.8886L23.2534 4.09937L23.4189 2.64785L22.0601 3.18427L9.28541 8.22709Z",
			fill: "#024860",
			stroke: "#4EA4BD",
			strokeWidth: 1.75397
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 26.4519L22.6179 25.659L20.0317 23.7923H11.5292L9 26.4519Z",
			fill: "#4EA4BD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.02734 26.4239L22.6035 25.6449V29H9.02734V26.4239Z",
			fill: "#06748D"
		})
	]
});
const ForwardRef = forwardRef(SvgPedroNarnia);
export default ForwardRef;
